import { StrategyAPI, UserAPI, WsRestAPI } from "./api";

/** WS call 请求 */
export interface WsCallReq {
  type?: "call";
  req_id: string;
  api: string;
  body?: Record<string, unknown>;
}

/** WS call 响应 */
export interface WsCallResp {
  type: "call";
  req_id: string;
  code: number;
  msg: string;
  success: boolean;
  /** gzip 分片时省略 inline data，见 encoding */
  encoding?: "gzip";
  format?: "compact" | "json";
  payload_bytes?: number;
  /** gzip 分片数，meta 告知需收集的 Binary 帧条数 */
  payload_chunks?: number;
  data: unknown;
}

/** arb/stat/data compact 列式 */
export interface ArbStatCompactPayload {
  schema: string[];
  rows: unknown[][];
}

export { WsRestAPI };

/** 与后端 registry.go / README §7 一致的白名单路径（normalize 后） */
const WSREST_ALLOWED_API_LIST = [
  UserAPI.GetUserApiBalanceList,
  UserAPI.GetUserApiPositionList,
  UserAPI.GetUserApiOpenOrderList,
  UserAPI.GetUserApiHistoryOrderList,
  StrategyAPI.GetInstanceList,
  StrategyAPI.GetInstanceInfoList,
  StrategyAPI.GetInstanceInfoListRobot,
  StrategyAPI.GetInstancePositionList,
  StrategyAPI.GetInstanceInfoStatVo,
  StrategyAPI.GetInstanceArbOptionNetvalues,
  StrategyAPI.GetInstanceArbStatData,
  StrategyAPI.GetObserverInstanceList,
  StrategyAPI.GetObserverInstanceInfoStatVo,
  StrategyAPI.GetObserverInstancePositionList,
] as const;

export function normalizeWsRestApi(api: string): string {
  const trimmed = api.trim();
  if (trimmed === "") {
    return trimmed;
  }
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}

export const WSREST_ALLOWED_APIS: ReadonlySet<string> = new Set(
  WSREST_ALLOWED_API_LIST.map(normalizeWsRestApi)
);
